import React from 'react'
import { useSelector } from 'react-redux'

import SocialValueGraph from '../SroiGraphsOld/SocialValueGraph'
import TotalSocialImpactByRoleGraph from '../SroiGraphsOld/TotalSocialImpactByRoleGraph'
import TotalSocialImpactGraph from '../SroiGraphsOld/TotalSocialImpactGraph'
import HeadcountAndPerBeneficiaryImpactGraph from '../SroiGraphsOld/HeadcountAndPerBeneficiaryImpactGraph'
import GenderGraph from '../SroiGraphsOld/GenderGraph'
import ReportSkeleton from './ReportSkeleton'
import TotalInfo from './TotalInfo'
import ErrorMessage from '../../../../components/Form/ErrorMessage'
import ImpactByRegion from '../SroiGraphsOld/ImpactByRegion'

import {
  getSocialReturnOnInvestmentReportErrorSelector,
  getSocialReturnOnInvestmentReportIsLoadingSelector
} from '../../../../modules/selectors/socialReturnOnInvestment'

import useStyles from './styles'

const ReportContent = () => {
  const classes = useStyles()

  const getSocialReturnOnInvestmentReportIsLoading = useSelector(getSocialReturnOnInvestmentReportIsLoadingSelector)
  const getSocialReturnOnInvestmentReportError = useSelector(getSocialReturnOnInvestmentReportErrorSelector)

  if (getSocialReturnOnInvestmentReportIsLoading) {
    return <ReportSkeleton />
  }

  if (getSocialReturnOnInvestmentReportError) {
    return <ErrorMessage className={classes.errorMessage} error={getSocialReturnOnInvestmentReportError.message} />
  }

  return (
    <>
      <TotalInfo />
      <div className={classes.graphsContainer}>
        <SocialValueGraph />
        <TotalSocialImpactByRoleGraph />
        <TotalSocialImpactGraph />
        <HeadcountAndPerBeneficiaryImpactGraph />
        <GenderGraph />
        <ImpactByRegion />
      </div>
    </>
  )
}

export default ReportContent
